import { createRouter, createWebHistory } from "vue-router";
import { haySesion, obtenerRol, rutaTrasLogin } from "@/lib/api";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      redirect: () => {
        if (!haySesion()) return "/login/";
        return rutaTrasLogin(obtenerRol());
      },
    },
    {
      path: "/login",
      redirect: "/login/",
    },
    {
      path: "/login/",
      name: "login",
      component: () => import("@/views/LoginView.vue"),
      meta: { guest: true },
    },
    {
      path: "/admin",
      redirect: "/admin/",
    },
    {
      path: "/admin/",
      component: () => import("@/views/admin/AdminLayout.vue"),
      meta: { requiresAuth: true, rol: "comercio" },
      children: [
        {
          path: "",
          redirect: "/admin/perfil/",
        },
        {
          path: "perfil/",
          name: "admin-perfil",
          component: () => import("@/views/admin/AdminPerfilView.vue"),
        },
        {
          path: "imagenes/",
          name: "admin-imagenes",
          component: () => import("@/views/admin/AdminSeccionView.vue"),
          props: { seccion: "imagenes" },
        },
        {
          path: "promociones/",
          name: "admin-promociones",
          component: () => import("@/views/admin/AdminSeccionView.vue"),
          props: { seccion: "promociones" },
        },
        {
          path: "menu/",
          name: "admin-menu",
          component: () => import("@/views/admin/AdminMenuView.vue"),
        },
        {
          path: "categorias/",
          name: "admin-categorias",
          component: () => import("@/views/admin/AdminCategoriasView.vue"),
        },
      ],
    },
    {
      path: "/super",
      redirect: "/super/",
    },
    {
      path: "/super/",
      component: () => import("@/views/super/SuperLayout.vue"),
      meta: { requiresAuth: true, rol: "super" },
      children: [
        {
          path: "",
          name: "super",
          component: () => import("@/views/super/SuperComerciosView.vue"),
        },
        {
          path: "plantillas/",
          name: "super-plantillas",
          component: () => import("@/views/super/SuperPlantillasView.vue"),
        },
      ],
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/",
    },
  ],
  scrollBehavior() {
    return { top: 0 };
  },
});

router.beforeEach((to) => {
  const sesion = haySesion();
  const rol = obtenerRol();

  if (to.meta.guest) {
    if (sesion) return rutaTrasLogin(rol);
    return true;
  }

  if (to.meta.requiresAuth) {
    if (!sesion) return "/login/";
    if (to.meta.rol && rol !== to.meta.rol) {
      return rutaTrasLogin(rol);
    }
  }

  return true;
});

export default router;
